/**
 * BalanceDisplay Component
 * Displays the viewer's current credit balance with casino-themed styling
 */

import React from 'react';
import './BalanceDisplay.css';

interface BalanceDisplayProps {
  balance: number;
}

export const BalanceDisplay: React.FC<BalanceDisplayProps> = ({ balance }) => {
  // Format balance with commas for thousands
  const formattedBalance = balance.toLocaleString('en-US');

  return (
    <div className="balance-display">
      <i className="bi bi-coin"></i>
      <span className="balance-label">Credits:</span>
      <span className="balance-amount">{formattedBalance}</span>
    </div>
  );
};

export default BalanceDisplay;
